<template>
  <PartnersLayout>
    <template #header>
      <PartnersHeader
        title="내 스플래시 광고"
        subtitle="스플래시 광고 신청 현황"
      />
    </template>

    <div class="px-4 lg:px-6 pb-6">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- 왼쪽: 바로가기 -->
          <div class="lg:col-span-1 space-y-4">
            <!-- 바로가기 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <h3 class="font-semibold text-slate-800 mb-3">바로가기</h3>
              <div class="space-y-2">
                <router-link
                  to="/partners/splash/purchase"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">광고 신청</p>
                    <p class="text-xs text-slate-500">새 스플래시 광고 등록</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link
                  to="/partners/ad/my"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">내 캠페인</p>
                    <p class="text-xs text-slate-500">캠페인 목록 확인</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link
                  to="/partners/leads/banner"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-amber-100 rounded-lg flex items-center justify-center group-hover:bg-amber-200 transition">
                    <svg class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">광고 유입 콜</p>
                    <p class="text-xs text-slate-500">광고로 들어온 상담</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
              </div>
            </div>

            <!-- 안내 카드 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <div class="flex items-center gap-2 mb-3">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3 class="font-semibold text-slate-800">광고 상태 안내</h3>
              </div>
              <ul class="text-sm text-slate-600 space-y-2">
                <li class="flex items-center gap-2">
                  <span class="w-2 h-2 bg-amber-400 rounded-full"></span>
                  <span><strong class="text-amber-600">승인 대기</strong> - 관리자 검토 중</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="w-2 h-2 bg-green-400 rounded-full"></span>
                  <span><strong class="text-green-600">승인됨</strong> - 노출 중</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="w-2 h-2 bg-red-400 rounded-full"></span>
                  <span><strong class="text-red-600">반려됨</strong> - 사유 확인</span>
                </li>
              </ul>
            </div>
          </div>

          <!-- 오른쪽: 메인 콘텐츠 -->
          <div class="lg:col-span-2">
            <!-- 로딩 -->
            <div v-if="loading" class="bg-white rounded-2xl border border-slate-200 p-12 flex items-center justify-center">
              <div class="spinner"></div>
            </div>

            <!-- 빈 상태 -->
            <div v-else-if="splashAds.length === 0" class="bg-white rounded-2xl border border-slate-200 p-12 text-center">
              <div class="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg class="w-10 h-10 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-slate-600 mb-2">스플래시 광고가 없습니다</h3>
              <p class="text-slate-400 mb-4">첫 스플래시 광고를 신청해보세요.</p>
              <router-link
                to="/partners/splash/purchase"
                class="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
              >
                스플래시 광고 신청
              </router-link>
            </div>

            <!-- 광고 목록 -->
            <div v-else class="space-y-4">
              <div
                v-for="ad in splashAds"
                :key="ad.id"
                class="bg-white rounded-2xl border border-slate-200 overflow-hidden"
              >
                <div class="flex">
                  <!-- 이미지 -->
                  <div class="w-32 h-48 bg-slate-100 flex-shrink-0">
                    <img
                      :src="ad.imageUrl"
                      :alt="ad.title"
                      class="w-full h-full object-cover"
                    />
                  </div>

                  <!-- 정보 -->
                  <div class="flex-1 p-5">
                    <div class="flex items-start justify-between mb-3">
                      <div>
                        <div class="flex items-center gap-2 mb-1">
                          <span :class="[
                            'px-2 py-0.5 text-xs font-semibold rounded-full',
                            getStatusClass(ad.status)
                          ]">{{ getStatusText(ad.status) }}</span>
                          <span class="text-xs text-slate-400">{{ ad.timeSlot?.label }} ({{ ad.timeSlot?.start }}-{{ ad.timeSlot?.end }})</span>
                        </div>
                        <h3 class="text-lg font-semibold text-slate-800">{{ ad.title }}</h3>
                        <p v-if="ad.subtitle" class="text-sm text-slate-500">{{ ad.subtitle }}</p>
                      </div>
                    </div>

                    <!-- 현장 정보 -->
                    <div class="flex items-center gap-2 mb-3">
                      <span class="px-2 py-1 text-xs bg-slate-100 text-slate-600 rounded">{{ ad.propertyName }}</span>
                      <span class="text-xs text-slate-400">{{ ad.campaignCode }}</span>
                    </div>

                    <!-- 통계 (승인된 경우) -->
                    <div v-if="ad.status === 'approved'" class="flex gap-4 mb-3">
                      <div class="text-center">
                        <p class="text-lg font-bold text-blue-600">{{ ad.impressions || 0 }}</p>
                        <p class="text-xs text-slate-400">노출</p>
                      </div>
                      <div class="text-center">
                        <p class="text-lg font-bold text-blue-600">{{ ad.clicks || 0 }}</p>
                        <p class="text-xs text-slate-400">클릭</p>
                      </div>
                      <div class="text-center">
                        <p class="text-lg font-bold text-blue-600">{{ getClickRate(ad) }}%</p>
                        <p class="text-xs text-slate-400">클릭률</p>
                      </div>
                    </div>

                    <!-- 반려 사유 -->
                    <div v-if="ad.status === 'rejected' && ad.rejectReason" class="p-3 bg-red-50 rounded-lg mb-3">
                      <p class="text-sm text-red-600">
                        <span class="font-medium">반려 사유:</span> {{ ad.rejectReason }}
                      </p>
                    </div>

                    <!-- 날짜 및 액션 -->
                    <div class="flex items-center justify-between">
                      <span class="text-xs text-slate-400">
                        신청일: {{ formatDate(ad.createdAt) }}
                        <span v-if="ad.approvedAt"> | 승인일: {{ formatDate(ad.approvedAt) }}</span>
                      </span>

                      <button
                        @click="cancelAd(ad)"
                        class="px-3 py-1.5 text-sm text-red-500 hover:bg-red-50 rounded-lg transition"
                      >
                        {{ ad.status === 'pending' ? '신청 취소' : '삭제' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PartnersLayout>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useAuth } from '@/composables/common/useAuth'
import { useSplashAd } from '@/composables/main/useSplashAd'
import PartnersLayout from '@/components/partners/common/PartnersLayout.vue'
import PartnersHeader from '@/components/partners/common/PartnersHeader.vue'

export default {
  name: 'MySplashAdsView',
  components: {
    PartnersLayout,
    PartnersHeader
  },
  setup() {
    const { user } = useAuth()
    const { getMySplashAds, cancelSplashAd } = useSplashAd()

    const loading = ref(true)
    const splashAds = ref([])

    const loadData = async () => {
      if (!user.value) return

      try {
        loading.value = true
        splashAds.value = await getMySplashAds(user.value.uid)
      } catch (error) {
        console.error('데이터 로드 실패:', error)
      } finally {
        loading.value = false
      }
    }

    const getStatusClass = (status) => {
      switch (status) {
        case 'pending': return 'bg-amber-100 text-amber-700'
        case 'approved': return 'bg-green-100 text-green-700'
        case 'rejected': return 'bg-red-100 text-red-700'
        default: return 'bg-slate-100 text-slate-600'
      }
    }

    const getStatusText = (status) => {
      switch (status) {
        case 'pending': return '승인 대기'
        case 'approved': return '승인됨'
        case 'rejected': return '반려됨'
        default: return status
      }
    }

    const getClickRate = (ad) => {
      if (!ad.impressions || ad.impressions === 0) return '0.0'
      return ((ad.clicks || 0) / ad.impressions * 100).toFixed(1)
    }

    const formatDate = (dateString) => {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`
    }

    const cancelAd = async (ad) => {
      if (!confirm('스플래시 광고 신청을 취소하시겠습니까?')) return

      try {
        await cancelSplashAd(ad.id)
        await loadData()
        alert('신청이 취소되었습니다.')
      } catch (error) {
        console.error('취소 실패:', error)
        alert('취소에 실패했습니다.')
      }
    }

    onMounted(loadData)

    return {
      loading,
      splashAds,
      getStatusClass,
      getStatusText,
      getClickRate,
      formatDate,
      cancelAd
    }
  }
}
</script>

<style scoped>
@reference "tailwindcss";

.spinner {
  @apply w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin;
}
</style>
